import { Col, Form, PageHeader, Row, Select, Button } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import ProgrammeService from "../../api/programme.service";
import { HP_PROGRAM_ID, SUCCESS_STATUS } from "../../utility/Constants";
import JcpHpPfMember from "../../components/jcp-pf-hp/JcpHpPfMember";
import { PrinterOutlined } from "@ant-design/icons";
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from "../../utility/URL";
const { Option } = Select;

const JcpHpPfMemberList = () => {
  const [form] = Form.useForm();
  const { program } = useParams();
  const [selectedProgram, setSelectedProgram] = useState(program);
  const [selectedProgrammGroupId, setSelectedProgramGroup] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("Y");
  const [programmeGroupList, setProgrammeGroupList] = useState([]);
  const [programmeID, setProgrammeID] = useState(0);
  const [programeList, setProgrameList] = useState([]);
  // console.log(program);

  const onSelectStatus = (value, event) => {
    setSelectedStatus(value);
  };

  const onSelectProgrammeGroup = (value, event) => {
    setSelectedProgramGroup(value);
  };

  const handlePrintButtonClick = async () => {
    try {
      // Submit form data
      const values = await form.validateFields();
      const url = `${PRINT_BASE_URL}member/list/${selectedProgram}/${selectedStatus}/${selectedProgrammGroupId}`;
      commonUtility.openInNewTab(url);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    ProgrammeService.programmeGroupList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeGroupList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    ProgrammeService.programmeList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const filteredProgrammes = res.data.response_data.filter(
          (programme) =>
            programme.short_code === "HP" || programme.short_code === "JHP"
        );
        setProgrameList(filteredProgrammes);
      }
    });
  }, []);

  const onSelectProgramme = (value, event) => {
    setSelectedProgram(value);  
      
  };

  return (
    <>
      <div className="inside-main-content">
        <AdminBreadCrumb />

        <div className="box-style">
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            // title={`${program} Member List`}
            title={`${program === "HP" ? `${program} Or JHP Member List` : `${program} Member List`}`}
            subTitle=""
            extra={[
              <Button
                key="gym_membership_pdf"
                className="custom-button-white"
                size="medium"
                onClick={handlePrintButtonClick}
              >
                <PrinterOutlined /> Print
              </Button>,
            ]}
          ></PageHeader>
          <>
            <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
              <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                <Form form={form} layout="vertical" autoComplete="off" initialValues={{ programme_id: program }}>
                  <Row gutter={10}>
                  {program != "HP" &&
                    <Col xs={6} xl={4}>
                      <Form.Item
                        name="group_id"
                        label="Programme Group (Shift)"
                      >
                        <Select
                          className="text-left"
                          onSelect={(value, event) =>
                            onSelectProgrammeGroup(value, event)
                          }
                         
                        >
                          <Option value="0">Select</Option>
                          {programmeGroupList.length > 0
                            ? programmeGroupList.map((programme_group_list) => (
                                <Option
                                  key={programme_group_list.programme_group_id}
                                  value={
                                    programme_group_list.programme_group_id
                                  }
                                >
                                  {programme_group_list.programme_group}
                                </Option>
                              ))
                            : ""}
                        </Select>
                      </Form.Item>
                    </Col>
}

                    <Col xs={6} xl={4}>
                      <Form.Item name="status" label="Member Status">
                        <Select
                          className="text-left"
                          onSelect={(value, event) =>
                            onSelectStatus(value, event)
                          }
                          defaultValue="Y"
                        >
                          <Option value="Y">Active</Option>
                          <Option value="N">Inactive</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    {program == "HP" &&
                    <Col xs={6} xl={4}>
                      <Form.Item
                        name="programme_id"
                        label="Programme"
                        labelCol={{ span: 24 }} // Makes the label take full width
                        wrapperCol={{ span: 24 }} // Ensures the Select input also takes full width
                        // style={{ marginBottom: 0 }}
                      >
                        <Select
                          showSearch
                          placeholder="Search to Select"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                          onSelect={(value, event) =>
                            onSelectProgramme(value, event)
                          }
                         
                        >
                          {programeList.length > 0
                            ? programeList.map((programe) => (
                                <Option
                                  key={programe.programme_id}
                                  value={programe.short_code}
                                >
                                  {`${programe.programme_name}`}
                                </Option>
                              ))
                            : ""}
                        </Select>
                      </Form.Item>
                    </Col>
}
                  </Row>
                </Form>
              </Col>
            </Row>
          </>

          <div className="tableView">
            <div className="form-content">
              <JcpHpPfMember
                programName={selectedProgram}
                groupId={selectedProgrammGroupId}
                memberStatus={selectedStatus}
              />
              {/* <JcpReceiptList /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JcpHpPfMemberList;
